import ruRU from './ru-ru'

export default { 'ru-ru': ruRU }
